import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-funding-source-list',
  templateUrl: './funding-source-list.component.html',
  styleUrls: ['./funding-source-list.component.css']
})
export class FundingSourceListComponent implements OnInit {
  fundingSources: any = [];
  totalResults = 0;
  totalPages = 0;
  currentPage = 1;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any;
  status = true;
  userPermission=UserPermission
  private readonly searchSubject = new Subject<string | undefined>();
  fundingSourceModalObj: any;

  constructor(
     private route: ActivatedRoute,
     private fundingSourceService: FundingSourceService,
     public permissionService: PermissionService,
     private router: Router
  ) { }

  ngOnInit() {
    this.getFundingSources(this.currentPage);
    this.listenSearch();
  }

  getFundingSources(page: number) {
    let queryparams: any = {
      limit: this.numberOfRecords,
      page,
      isActive: this.status,
      sortBy: 'title:asc'
    }

    if (this.search) {
    queryparams['search'] = this.search;
    this.fundingSourceService
      .search(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results;
          this.fundingSources = data.results.sort((a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      });
    }
    else {
      this.fundingSourceService
        .get(queryparams)
        .pipe(untilDestroyed(this)).subscribe((data: any) => {
          if (data && data.results) {
            this.fundingSources = data.results;
            this.fundingSources = data.results.sort((a: any, b: any) =>
              a.title.localeCompare(b.title)
            );
            this.totalPages = data.totalPages;
            this.totalResults = data.totalResults;
          }
        });
    }

  }

  onSelectStatus(event: any): void {
    this.status = event.target.value === "true";
    this.getFundingSources(this.currentPage = 1)
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getFundingSources(page);
  }

  onSearch(query: any) {
    if (query) {
      this.searchSubject.next(query);
    } else {
      this.currentPage = 1;
      this.getFundingSources(this.currentPage);
    }
  }

  listenSearch() {
    this.searchSubject
      .pipe(debounceTime(500))
      .pipe(untilDestroyed(this)).subscribe((search) => {
        this.currentPage = 1;
        this.fundingSources = [];
        this.getFundingSources(this.currentPage);
      });
  }

  openFundingSourceModal(fundingSource: any) {
    this.fundingSourceModalObj = fundingSource;
  }

  onSaveFundingSource(evt: any) {
    this.getFundingSources(this.currentPage);
    this.fundingSourceModalObj = null;
  }

  onCloseFundingSourceModal() {
    this.fundingSourceModalObj = null;
  }

  openFareWindow(fsId: any) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/funding-sources/${fsId}/fare`])
    );
    window.open(url, "_blank");
  }
}
